export default __webpack_public_path__ + "static-json/ne_50m_lakes-1c9ea08e73fff888326a6502ee61e019.json";